module.exports = __webpack_public_path__ + "icon_alert_25red.93806.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_alert_25red.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_alert_25red.svg
// module chunks = main